<template>
  <div class="custom-table" @mouseover="stopScroll" @mouseleave="autoScroll">
    <div class="custom-table-header">
      <div
        class="table-column-item"
        :style="getRowStyle(item)"
        v-for="(item, index) in header"
        :key="'x' + index"
      >
        <div class="text">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="custom-table-body mens" ref="lists">
      <div
        class="custom-table-item men"
        :class="{ menoff: index % 2 !== 0 }"
        v-for="(data, index) in tableData"
        :key="'c' + index"
      >
        <div
          class="table-column-item"
          :style="getRowStyle(item)"
          v-for="(item, index) in header"
          :key="'xx' + index"
        >
          <el-tooltip
            class="box-item"
            effect="dark"
            :content="String(data[item.key])"
            placement="bottom-start"
          >
            <div class="text">{{ data[item.key] }}</div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Scroll, Stop } from "@/utils/index.js";
export default {
  name: "auto-table",
  props: {
    header: [],
    tableData: {
      type: Array,
      default: () => {
        return {
          tableData: [],
        };
      },
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  mounted() {
    this.autoScroll();
  },
  methods: {
    getRowStyle(item) {
      return {
        width: item.width + "px",
        textAlign: item.align,
      };
    },
    autoScroll() {
      Scroll(this.$refs.lists, "cd");
    },

    stopScroll() {
      Stop("cd");
      //   clearInterval(this.intv);
    },
  },
};
</script>

<style lang="scss" scoped>
.mens::-webkit-scrollbar {
  width: 0px;
  background: rgb(59, 59, 59);
}

.mens::-webkit-scrollbar-thumb {
  width: 2px;
  background: rgb(128, 128, 128);
}
.mens {
  font-size: 12px;
  overflow-x: hidden;
  overflow-y: auto;
  .menoff {
    white-space: nowrap;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    background: rgba(255, 255, 255, 0.1);
  }
  .men {
    white-space: nowrap;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    display: flex;
    justify-content: space-between;
  }
}
.custom-table {
  width: 100%;
  height: 100%;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  //   justify-content: space-between;
  .custom-table-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.1);
  }
  .custom-table-body {
    flex-grow: 1;
    overflow-y: auto;
  }
  .table-column-item {
    height: 32px;
    display: flex;
    align-items: center;

    .text {
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: 400;
      font-size: 18px;
      line-height: 27px;
      color: #e5e5e5;
    }
  }
  .custom-table-item {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .table-column-properties {
      flex: 0;
    }
    .text {
      font-size: 14px;
      line-height: 21px;
      color: #ffffff;
    }
  }
}
</style>
